import classes from "./FreeportForm.module.scss";
import { useSelectedFormContext } from "../../../../../context/SelectedForm/selected-form-context";
import { useEffect, useState, useMemo } from "react";
import {
  getSelectedFormDataHelper,
  getSelectedFormEntryDataHelper,
  saveFormHelper,
} from "../../../../../context/SelectedForm/selected-form-context.helper";
import {
  IFormEntryModel,
} from "../../../../../interfaces/form-entry.interface";
import {
  IFormFiledInterface,
} from "../../../../../interfaces/form-filed.interface";
import { useNavigate } from "react-router-dom";
import {
  IFormSettingModel,
} from "../../../../../interfaces/form-settings.interface";
import { Dialog } from "@progress/kendo-react-dialogs";
import { SelectedFormActionsEnum } from "../../../../../context/SelectedForm/selected-form-actions";
import { useFormContext } from "../../../../../context/Form/form-context";
import {
  onLoadForms
} from "../../../../../context/Form/form-helper";
import { CustomLoader } from "../../../../../components";
import { FormActionsEnum } from "../../../../../context/Form/form-actions";
import { useCallbackPrompt } from "../../../../../hooks/useCallbackPrompt";
import UnsavedFormDialog from "../../../../../components/CustomDialogs/UnsavedFormDialog/UnsavedFormDialog";
import { t } from "i18next";
import AuthService from 'src/services/authentication.service';
import { FreeportFormFirstSectionInterface, IFreeportFormFirstSectionInterface } from "src/interfaces/forms/FreeportForm/freeport-form-first-section.interface";
import { FreeportFormName } from "src/constants/form-names-constants";
import FreeportFormFirstSection from "./FreeportFormFirstSection";
import { useFormSectionDataFields } from "../useFormSectionDataFields";
import { IFreeportFormFifthSectionInterface, FreeportFormFifthSectionInterface } from "src/interfaces/forms/FreeportForm/freeport-form-fifth-section.interface";
import { IFreeportFormFourthSectionInterface, FreeportFormFourthSectionInterface } from "src/interfaces/forms/FreeportForm/freeport-form-fourth-section.interface";
import { IFreeportFormSecondSectionInterface, FreeportFormSecondSectionInterface } from "src/interfaces/forms/FreeportForm/freeport-form-second-section.interface";
import { FreeportFormSixthSectionInterface, IFreeportFormSixthSectionInterface } from "src/interfaces/forms/FreeportForm/freeport-form-sixth-section.interface";
import { IFreeportFormThirdSectionInterface, FreeportFormThirdSectionInterface } from "src/interfaces/forms/FreeportForm/freeport-form-third-section.interface";
import FreeportFormSixthSection from "./FreeportFormSixthSection";
import FreeportFormFifthSection from "./FreeportFormFifthSection";
import FreeportFormFourthSection from "./FreeportFormFourthSection";
import FreeportFormThirdSection from "./FreeportFormThirdSection";
import FreeportFormSecondSection from "./FreeportFormSecondSection";
import FreeportFormPDFView from "src/pages/Shared/FreeportFormPDFView/FreeportFormPDFView";
import { FormHeader } from "../Shared/FormHeader/FormHeader";
import { submitted } from "src/constants/submission-form-status-constants";
import { useIsFormActive } from "../useIsFormActive";
import { FreeportDisclaimer } from "./FreeportDisclaimer";
import { FreeportFilingWindowDisclaimer } from "./FreeportFilingWindowDisclaimer";

interface FormEntry {
  formEntryId?: number;
  isAdminPreview?: boolean;
  formId?: number;
}

export default function FreeportForm(props: FormEntry): JSX.Element {
    const { isAuthorized } = AuthService.getInstance();

    const { isAdminPreview, formEntryId, formId } = props;
    const { formState, formDispatch } = useFormContext();
    const { selectedFormDispatch, selectedFormState } = useSelectedFormContext();
    const { loading } = formState;
    const { isLoading } = selectedFormState;
    const [formDataFields, setFormDataFields] = useState<Array<IFormFiledInterface>>();
    const [formEntry, setFormEntry] = useState<IFormEntryModel>();
    const formSettings = useMemo(() => {
      let formSettings = selectedFormState.formSettings ?? undefined;
      if (
          !isAuthorized ||
          isAdminPreview ||
          selectedFormState.formEntry?.submissionStatus == submitted
       ) {
        formSettings = { ...formSettings, isReadOnly: true };
       }
       return formSettings;
    }, [selectedFormState.formSettings, selectedFormState.formEntry, isAuthorized, isAdminPreview]);

    const [formFirstSectionDataFields, setFormFirstSectionDataFields] = useState<IFreeportFormFirstSectionInterface>();
    const [formSecondSectionDataFields, setFormSecondSectionDataFields] = useState<IFreeportFormSecondSectionInterface>();
    const [formThirdSectionDataFields, setFormThirdSectionDataFields] = useState<IFreeportFormThirdSectionInterface>();
    const [formFourthSectionDataFields, setFormFourthSectionDataFields] = useState<IFreeportFormFourthSectionInterface>();
    const [formFifthSectionDataFields, setFormFifthSectionDataFields] = useState<IFreeportFormFifthSectionInterface>();
    const [formSixthSectionDataFields, setFormSixthSectionDataFields] = useState<IFreeportFormSixthSectionInterface>();

    const [firstSectionIsValid, setFirstSectionIsValid] = useState<boolean>(false);
    const [secondSectionIsValid, setSecondSectionIsValid] = useState<boolean>(false);
    const [thirdSectionIsValid, setThirdSectionIsValid] = useState<boolean>(false);
    const [fourthSectionIsValid, setFourthSectionIsValid] = useState<boolean>(false);
    const [fifthSectionIsValid, setFifthSectionIsValid] = useState<boolean>(false);
    const [sixthSectionIsValid, setSixthSectionIsValid] = useState<boolean>(false);

    const [isFormValid, setIsFormValid] = useState<boolean>(false);

    const { isFormActive } = useIsFormActive(
      isAuthorized,
      isAdminPreview,
      formSettings,
      "AdditionalDocuments",
      selectedFormState.formFields,
      formFifthSectionDataFields?.AdditionalDocuments
    );
    const [showPrompt, confirmNavigation, cancelNavigation, setDisablePrompt] = useCallbackPrompt(isFormActive);

    const [showDisclaimer, setShowDisclaimer] = useState(false);
    const [showFilingWindowDisclaimer, setFilingWindowDisclaimer] = useState(false);

    useEffect(() => {
      setIsFormValid(
        firstSectionIsValid &&
        secondSectionIsValid &&
        thirdSectionIsValid &&
        fourthSectionIsValid &&
        fifthSectionIsValid &&
        sixthSectionIsValid)
    }, [
      firstSectionIsValid,
      secondSectionIsValid,
      thirdSectionIsValid,
      fourthSectionIsValid,
      fifthSectionIsValid,
      sixthSectionIsValid])

    useEffect(() => {
      return () => {
        selectedFormDispatch({
          type: SelectedFormActionsEnum.CLEAR,
          payload: {
            errorMessage: undefined,
            isLoading: undefined,
            formFields: undefined,
            successMessage: undefined,
            form: undefined,
            formSettings: undefined,
            formEntry: undefined,
            status: SelectedFormActionsEnum.CLEAR
          },
        });
      }
    }, []);

    useEffect(() => {
          const disclaimerFormText = formState.forms?.find(x => x.name === FreeportFormName)?.disclaimerText ?? "";
          const FilingWindowPopUpDisclaimerFormText = formState.forms?.find(x => x.name === FreeportFormName)?.nonFillableMessage ?? "";
          if (!formEntryId && disclaimerFormText.trim().length > 0) {
            setShowDisclaimer(true);
          }
          if (!formEntryId && FilingWindowPopUpDisclaimerFormText.trim().length > 0) {
          setFilingWindowDisclaimer(true);
        }
        }, [formEntryId, formState?.forms]);

    useEffect(() => {
      if (!formState.forms.length) {
        onLoadForms(formDispatch);
      }
    }, []);

    useEffect(() => {
      const stateFormId = formState?.forms?.find(x => x.name == FreeportFormName)?.id ?? formId;

      if (stateFormId && isAuthorized) {
        if (formEntryId) {
          getSelectedFormEntryDataHelper(selectedFormDispatch, stateFormId, formEntryId);
        } else {
          getSelectedFormDataHelper(selectedFormDispatch, stateFormId);
        }
      }
    }, [formState.forms]);

    useEffect(() => {
      if (selectedFormState?.formEntry) {
        if (selectedFormState.form?.name) {
          setFormEntry({
            ...selectedFormState?.formEntry,
            formName: selectedFormState.form?.name
          });
        } else {
          setFormEntry(selectedFormState.formEntry)
        }
      }
    }, [selectedFormState.formEntry, selectedFormState.form]);

    function ClearData() {
      setFormDataFields([]);
      setFormEntry(undefined);
      setFormFirstSectionDataFields({});
      setFormSecondSectionDataFields({});
      setFormThirdSectionDataFields({});
      setFormFourthSectionDataFields({});
      setFormFifthSectionDataFields({});
      setFormSixthSectionDataFields({});
      setFirstSectionIsValid(false);
      setSecondSectionIsValid(false);
      setThirdSectionIsValid(false);
      setFourthSectionIsValid(false);
      setFifthSectionIsValid(false);
      setSixthSectionIsValid(false);

      setDisablePrompt(false);
    }

    useEffect(() => {
      if (selectedFormState.status === SelectedFormActionsEnum.CLEAR) {
        ClearData();
        return;
      }

      setFormDataFields(selectedFormState.formFields);
      const FirstSection: IFreeportFormFirstSectionInterface = FreeportFormFirstSectionInterface();
      const SecondSection: IFreeportFormSecondSectionInterface = FreeportFormSecondSectionInterface();
      const ThirdSection: IFreeportFormThirdSectionInterface = FreeportFormThirdSectionInterface();
      const FourthSection: IFreeportFormFourthSectionInterface = FreeportFormFourthSectionInterface();
      const FifthSection: IFreeportFormFifthSectionInterface = FreeportFormFifthSectionInterface();
      const SixthSection: IFreeportFormSixthSectionInterface = FreeportFormSixthSectionInterface();

      selectedFormState?.formFields.forEach((f) => {
        if (f.name in FirstSection) {
          if (f.type == "boolean") {
            (FirstSection as any)[f.name] = JSON.parse(f.value);
          } else if (f.type == "string") {
            (FirstSection as any)[f.name] = f.value?.trim();
          }
        } else if (f.name in SecondSection) {
          if (f.type == "boolean") {
            (SecondSection as any)[f.name] = JSON.parse(f.value);
          } else if (f.type == "string") {
            (SecondSection as any)[f.name] = f.value?.trim();
          } else if (f.type == "object") {
            (SecondSection as any)[f.name] = JSON.parse(f.value);
          }
        } else if (f.name in ThirdSection) {
          if (f.type == "boolean") {
            (ThirdSection as any)[f.name] = JSON.parse(f.value);
          } else if (f.type == "string") {
            (ThirdSection as any)[f.name] = f.value?.trim();
          }
        } else if (f.name in FourthSection) {
          if (f.type == "boolean") {
            (FourthSection as any)[f.name] = JSON.parse(f.value);
          } else if (f.type == "string") {
            (FourthSection as any)[f.name] = f.value?.trim();
          } else if (f.type == "number") {
            (FourthSection as any)[f.name] = +f.value;
          } else if (f.type == "object") {
            (FourthSection as any)[f.name] = JSON.parse(f.value);
          }
        } else if (f.name in FifthSection) {
          if (f.type == "object") {
            (FifthSection as any)[f.name] = JSON.parse(f.value);
          }
        } else if (f.name in SixthSection) {
          if (f.type == "string") {
            (SixthSection as any)[f.name] = f.value?.trim();
          } if (f.type == "object") {
            (SixthSection as any)[f.name] = JSON.parse(f.value);
          }
        }

      });
      if (selectedFormState.formFields.length > 0) {
        setFormFirstSectionDataFields(FirstSection);
        setFormSecondSectionDataFields(SecondSection);
        setFormThirdSectionDataFields(ThirdSection);
        setFormFourthSectionDataFields(FourthSection);
        setFormFifthSectionDataFields(FifthSection);
        setFormSixthSectionDataFields(SixthSection);
      }
    }, [selectedFormState.formFields]);

    useFormSectionDataFields({
      sectionFields: formFirstSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formSecondSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formThirdSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formFourthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formFifthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    useFormSectionDataFields({
      sectionFields: formSixthSectionDataFields,
      formDataFields: formDataFields,
      setFormDataFields: setFormDataFields,
      formId: formEntry?.formId,
      formEntryId: formEntry?.id
    });

    const navigate = useNavigate();

    function saveHandler() {
      setDisablePrompt(true);
      const temp = {
        ...formEntry,
        formName: selectedFormState.form?.name,
        submissionStatus: "Saved",
      } as IFormEntryModel;
      setFormEntry(temp);
      if (selectedFormState.form?.name) {
        saveFormHelper(selectedFormDispatch, selectedFormState.form?.name, temp, formDataFields!, navigate);
      }
    }

    function setFormEntryBase64Url(url: string) {
      setFormEntry({ ...formEntry, pdfBase64Url: url } as IFormEntryModel);
    }

    function submitHandler() {
      const temp = {
        ...formEntry,
        formName: selectedFormState.form?.name,
        submissionStatus: "Submitted",
      } as IFormEntryModel;
      setFormEntry(temp);
      setDisablePrompt(true);

      if (selectedFormState.form?.name) {
        saveFormHelper(selectedFormDispatch, selectedFormState.form?.name, temp, formDataFields!, navigate);
      }
    }

    const [visible, setVisible] = useState<boolean>(false);
    const [submit, setSubmit] = useState<boolean>(false);

    const toggleDialog = () => {
      setVisible(!visible);
    };

    const toggleSubmitDialog = () => {
      setSubmit(!submit);
      setVisible(!visible);
    };

    const dialogTitle = (
      <div>
        {submit &&  formEntry?.submissionStatus != "Submitted" && (
          <button className="button" onClick={submitHandler}>
            submit form
          </button>
        )}
      </div>
    );

    return <>
      <div className={classes.form}>
        {visible && (
          <Dialog
            className="customFormDialog"
            title={dialogTitle}
            onClose={submit ? toggleSubmitDialog : toggleDialog}
            width={"70vw"}
            height={"90vh"}
          >
            <FreeportFormPDFView
              getPdfBase64Url={setFormEntryBase64Url}
              formDataFieldsFirstSection={formFirstSectionDataFields}
              formDataFieldsSecondSection={formSecondSectionDataFields}
              formDataFieldsThirdSection={formThirdSectionDataFields}
              formDataFieldsFourthSection={formFourthSectionDataFields}
              formDataFieldsFifthSection={formFifthSectionDataFields}
              formDataFieldsSixthSection={formSixthSectionDataFields}
            />
          </Dialog>
        )}

        <FormHeader
          formName={FreeportFormName}
          isAdminPreview={isAdminPreview}
          isAuthorized={isAuthorized}
          formEntry={formEntry}
          formSettings={formSettings}
          isFormValid={isFormValid}
          onPrint={() => toggleDialog()}
          onSave={() => saveHandler()}
          onSubmit={() => toggleSubmitDialog()}
        />

        <FreeportFormFirstSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formFirstSectionDataFields}
          setFormDataFields={setFormFirstSectionDataFields}
          setFormIsValid={setFirstSectionIsValid}
        />

        <FreeportFormSecondSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formSecondSectionDataFields}
          setFormDataFields={setFormSecondSectionDataFields}
          setFormIsValid={setSecondSectionIsValid}
        />

        <FreeportFormThirdSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formThirdSectionDataFields}
          setFormDataFields={setFormThirdSectionDataFields}
          setFormIsValid={setThirdSectionIsValid}
        />

        <FreeportFormFourthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formFourthSectionDataFields}
          setFormDataFields={setFormFourthSectionDataFields}
          setFormIsValid={setFourthSectionIsValid}
        />

        <FreeportFormFifthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formEntry={formEntry}
          formDataFields={formFifthSectionDataFields}
          setFormDataFields={setFormFifthSectionDataFields}
          setFormIsValid={setFifthSectionIsValid}
          selectedFormDispatch={selectedFormDispatch}
        />

        <FreeportFormSixthSection
          isAdminPreview={isAdminPreview}
          formSettings={formSettings}
          formDataFields={formSixthSectionDataFields}
          setFormDataFields={setFormSixthSectionDataFields}
          setFormIsValid={setSixthSectionIsValid}
        />

        {(!isFormValid && !formSettings?.isReadOnly) &&
          <div className={classes.invalidForm}>
            <h2>Please Fill All Required Fields in Steps:</h2>
            {!firstSectionIsValid &&
              <div className={classes.item}>
                1.   Property Owner/Applicant
              </div>}
            {!secondSectionIsValid &&
              <div className={classes.item}>
                2.   Authorized Representative
              </div>}
            {!thirdSectionIsValid &&
              <div className={classes.item}>
                3.   Property Information
              </div>}
            {!fourthSectionIsValid &&
              <div className={classes.item}>
                4.   Questions About Your Property
              </div>}
            {!fifthSectionIsValid &&
              <div className={classes.item}>
                5.   Additional Documents to be Provided
              </div>}
            {!sixthSectionIsValid &&
              <div className={classes.item}>
                6.   Certification and Signature
              </div>}
          </div>}

        {isAuthorized && !isAdminPreview &&
          !formSettings?.isReadOnly &&
          formEntry?.submissionStatus != "Submitted" && (
            <span className="buttons-group">
              <button disabled={!isFormValid}
                className="button"
                onClick={() => toggleSubmitDialog()}
              >
                <i className="fa fa-tasks fa-fw"></i>
                Review & Submit
              </button>
            </span>
          )}
      </div>
      {showDisclaimer && (
            <FreeportDisclaimer 
                disclaimerText={formState?.forms?.find(x => x.name == FreeportFormName)?.disclaimerText?.trim() || ""}
                onClose={() => setShowDisclaimer(false)} />)}
      {showFilingWindowDisclaimer && (
                <FreeportFilingWindowDisclaimer 
                    disclaimerText={formState?.forms?.find(x => x.name == FreeportFormName)?.nonFillableMessage?.trim() || ""}
                    onClose={() => setFilingWindowDisclaimer(false)} />)}  
      {(loading || isLoading) && <CustomLoader />}
      {showPrompt && isAuthorized && (!loading && !isLoading) && (
        <UnsavedFormDialog
          onConfirm={confirmNavigation}
          onCancel={cancelNavigation}
        />
      )}
    </>
  }